var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export var ActivitySource;
(function (ActivitySource) {
    ActivitySource["GHCC"] = "GHCC";
    ActivitySource["GoodHabitz"] = "GoodHabitz";
})(ActivitySource || (ActivitySource = {}));
export const getMeasurementStartTime = () => Date.now();
export const measureTimespanInSecs = (startTime, endTime) => Math.floor((endTime - startTime) / 1000);
export const sendActivityMetricsToDatadog = (token, metrics) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch('https://course-bff.goodhabitz.com/metrics/activity/init', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
            body: JSON.stringify(metrics),
        });
        return response.json();
    }
    catch (err) {
        console.warn('An error occured while sending metrics to Datadog!', err);
    }
});
//# sourceMappingURL=metricUtils.js.map